import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bodyTypeSelect"]
  static values = { url: String }

  updateBodyType(event) {
    const modelId = event.target.value
    if (!modelId || !this.hasBodyTypeSelectTarget) return

    const bodyTypeSelect = this.bodyTypeSelectTarget
    const url = this.urlValue.replace(":id", modelId)

    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.body_type_id) {
          bodyTypeSelect.value = data.body_type_id

          if (bodyTypeSelect.tomselect) {
            bodyTypeSelect.tomselect.setValue(data.body_type_id, true)
          }
        }
      })
      .catch(error => console.error("Error loading body type:", error))
  }
}
